export const procedureListHeaders = [
  { header: 'procedureCode', label: 'PROCEDURE CODE' },
  { header: 'procedureName', label: 'PROCEDURE NAME' },
  { header: 'programCode', label: 'PROGRAM CODE' },
  { header: 'programName', label: 'PROGRAM NAME' },
  { header: 'aggregatorProcedureCode', label: 'AGGREGATOR CODE' },
  { header: 'modifiers', label: 'MODIFIERS' },
  { header: 'type', label: 'TYPE' },
  { header: 'isProcedureCode', label: 'IS PROCEDURE CODE' },
  { header: 'notes', label: 'NOTES' },
];
